import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { commandeBCIService } from '../../../services/entityService';
import { CommandeBCI } from '../types';

// Chargement de la commande prestataire BCI (GET /bdci/commande/{id} via EntityService :
// reponse {status, data} + mapping `formulaire`). Expose un refetch explicite pour rafraichir
// l'etat React apres l'envoi de l'offre, au lieu du window.location.reload() de l'ancienne infra.
export const useCommandeData = () => {
  const { id } = useParams<{ id: string }>();
  const [commande, setCommande] = useState<CommandeBCI | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCommande = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      const data = (await commandeBCIService.getById(id)) as CommandeBCI;
      setCommande(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur lors du chargement');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchCommande();
  }, [fetchCommande]);

  return { commande, setCommande, loading, error, refetch: fetchCommande };
};
